/* eslint-disable object-curly-spacing */

import { SubmissionError } from 'redux-form';

export function handleSampleOrderError(error) {
  if (error instanceof SubmissionError) {
    throw error;
  }
  throw new SubmissionError({
    _error: `Не удалось отправить форму. Проверьте подключение к интернету и попробуйте ещё раз.`
  });
}

export default function handleSampleOrderResponse(response) {
  return response
    .json()
    .then((responseData) => {
      if (responseData.error) {
        throw new SubmissionError({ _error: responseData.error });
      }
      if (response.status >= 400 || !responseData.response) {
        throw new Error(`Unexpected Response`);
      }
      return responseData;
    })
    .catch(handleSampleOrderError);
}
